import { useMsal } from '@azure/msal-react';
import {
    CircularProgress,
    Container
} from '@material-ui/core';
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, GridValueFormatterParams, GridValueGetterParams, LocalizationV4 } from "@material-ui/data-grid";
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { selectDate } from "../../../features/konfiguration/konfigurationSlice";
import { getMessstellenForLookup, selectMessstellenLookup, selectMessstellenLoadingLookup } from '../../../features/messstellenLookup/messstellenLookupSlice';
import { alphaNumSort, dateDiffInDays, dateDiffInDaysUTC, toUTCDateString } from '../../../utils/utils';
import { getNetzereignisse, netzereignisDummy, selectNetzereignisLoading, selectNetzsereignisseListe, selectSorting, setSorting, updateAktuellesNetzereignis } from './netzereignisseSlice';
import { useStyles } from './netzereignisseStyles';
import { useParams } from 'react-router';


export const NetzereignisseGrid: React.FC = () => {

    const dispatch = useAppDispatch();
    const translateGeplantBoolToString = (geplant: boolean) => {
        return geplant ? "Geplant" : "Ungeplant";
    }

    const { instance } = useMsal();

    const { id } = useParams<{id: string | undefined}>();

    useEffect(() => {
        dispatch(getNetzereignisse(id));
        dispatch(getMessstellenForLookup());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const messstellenLookupListe = useAppSelector(selectMessstellenLookup);
    const messstellenLookupLoadingListe = useAppSelector(selectMessstellenLoadingLookup);
    const netzereignisLoading = useAppSelector(selectNetzereignisLoading);
    const sorting: GridSortModel = useAppSelector(selectSorting);
    const data = useAppSelector(selectNetzsereignisseListe);
    const isUTC = useAppSelector(selectDate);

    const dataGridCols2: GridColDef[] = [
        {
            field: 'uw', headerName: 'Umspannwerk', flex: 0.8,
            valueGetter: (params: GridValueGetterParams) => {
                return messstellenLookupListe.length == 0 ? "Wird geladen..." : messstellenLookupListe.find(x => x.name == params.getValue(params.id, 'messstelle'))?.umspannwerk;
            },
        },
        {
            field: 'schaltfeld', headerName: 'Schaltfeld', flex: 0.8,
            valueGetter: (params: GridValueGetterParams) => {
                return messstellenLookupListe.length == 0 ? "Wird geladen..." : messstellenLookupListe.find(x => x.name == params.getValue(params.id, 'messstelle'))?.schaltfeld;
            },
        },
        { field: 'messstelle', headerName: 'Messstelle', flex: 0.6, sortComparator: alphaNumSort },
        { field: 'ereignisueberschrift', headerName: 'Ereignisüberschrift', filterable: false, flex: 0.8 },
        {
            field: 'geplant', headerName: 'Geplant/Ungeplant', flex: 0.8, valueFormatter: (params: GridValueFormatterParams) => {
                const geplant = params.getValue(params.id, 'geplant');
                return translateGeplantBoolToString(Boolean(geplant));
            }
        },
        {
            field: 'zeit', headerName: 'Startzeit', flex: 0.8, filterable: false, valueFormatter: (params: GridValueFormatterParams) => {
                const startD = params.getValue(params.id, 'zeit');
                const startDString = startD ? startD.toString() : "";

                return (isUTC ? toUTCDateString(new Date(startDString)) : new Date(startDString).toLocaleString());
            }
        },
        {
            field: 'ende', headerName: 'Endzeit', flex: 0.8, filterable: false, valueFormatter: (params: GridValueFormatterParams) => {
                const endeD = params.getValue(params.id, 'ende');
                const endeDString = endeD ? endeD.toString() : "";
                return (isUTC ? toUTCDateString(new Date(endeDString)) : new Date(endeDString).toLocaleString());
            }
        },
        {
            field: 'anzahlTage', headerName: 'Anzahl Tage', flex: 0.7, valueFormatter: (params: GridValueFormatterParams) => {
                const startD = params.getValue(params.id, 'zeit');
                const endeD = params.getValue(params.id, 'ende');
                const startDString = startD ? startD.toString() : "";
                const endDString = endeD ? endeD.toString() : "";

                return (isUTC ? dateDiffInDaysUTC(new Date(startDString), new Date(endDString)) : dateDiffInDays(new Date(startDString), new Date(endDString)));
            }
        },
        { field: 'grund', headerName: 'Grund', flex: 0.5, },
        { field: 'freischaltung', headerName: 'Freischaltungen', flex: 0.7, }
    ]

    return (
        <Container maxWidth={false} className={classes.root}>
            <div style={{ height: "50vh", width: '100%' }}>
                {netzereignisLoading ? <CircularProgress /> : <DataGrid
                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                    columns={dataGridCols2}
                    disableColumnSelector={true}
                    rows={data}
                    sortModel={sorting}
                    onSortModelChange={(model) => setSorting(model.sortModel)}
                    onRowClick={(param: GridRowParams) => {
                        let mt = netzereignisDummy;
                        const temp = data.find(mst => mst.id == (param.row.id as number))
                        if (temp)
                            mt = temp;
                        dispatch(updateAktuellesNetzereignis(mt));
                    }}
                    loading={netzereignisLoading && messstellenLookupLoadingListe}
                />}
            </div>
        </Container >)
}
